var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from "react";
import { useContext } from "react";
import ThemeProviderContext from "../contexes/themeProviderContext";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { SecondaryStyledButton } from "./styleComponents";
var IconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0.5rem;\n"], ["\n  margin: 0.5rem;\n"])));

var SuccessIcon = function SuccessIcon() {
  return React.createElement(IconWrapper, null, React.createElement(FontAwesomeIcon, {
    icon: faCheck
  }));
};

var FailureIcon = function FailureIcon() {
  return React.createElement(IconWrapper, null, React.createElement(FontAwesomeIcon, {
    icon: faTimes
  }));
};

var ChoiceButton = styled(SecondaryStyledButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n\n  margin: 0.5em 0;\n\n  &:hover {\n    background: #e5c7b5;\n    box-shadow: none;\n  }\n\n  &:focus {\n    ", "\n  }\n"], ["\n  ", "\n  ", "\n\n  margin: 0.5em 0;\n\n  &:hover {\n    background: #e5c7b5;\n    box-shadow: none;\n  }\n\n  &:focus {\n    ", "\n  }\n"])), function (_a) {
  var direction = _a.direction;
  return direction === "column" && "width: 90%;";
}, function (_a) {
  var state = _a.state;
  return state && "background-color: #E3B599;";
}, function (_a) {
  var state = _a.state;
  return state ? "background-color: #E3B599;" : "background-color: #E0E0E0;";
});
var RevealedChoiceButton = styled(function (_a) {
  var selected = _a.selected,
      correct = _a.correct,
      others = __rest(_a, ["selected", "correct"]);

  return React.createElement(ChoiceButton, __assign({
    state: false,
    variant: "contained",
    selected: selected,
    fullWidth: true
  }, others), selected ? correct ? React.createElement(SuccessIcon, null) : React.createElement(FailureIcon, null) : "", others.children);
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
  return props.selected ? "\n      color: #fff;\n      background-color: " + (props.correct ? "#047500" : "#DB0000") + ";\n      " : props.correct ? "\n      color: #047500;\n      border-color: #047500;\n      border-width: 3px\n      " : "";
});
export default (function (props) {
  var themeProvider = useContext(ThemeProviderContext);

  var revealed = props.revealed,
      others = __rest(props, ["revealed"]);

  var ThemedButton = themeProvider.choiceButton;

  if (ThemedButton) {
    return React.createElement(ThemedButton, __assign({}, props));
  }

  return revealed ? React.createElement(RevealedChoiceButton, __assign({}, others)) : React.createElement(ChoiceButton, __assign({
    variant: "contained",
    fullWidth: true
  }, others));
});
var templateObject_1, templateObject_2, templateObject_3;